export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',
	REGISTER = 'register',

	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',

	PRODUCTS = 'product',
	PRODUCT_MODELS = 'product-models',
	ORDERS = 'orders',
	SHIPPING_METHODS = 'shipping-methods',
	SHIPPING_PRIORITY = 'shipping-priority',

	ADMINS = 'admins',
	LOGIN_HISTORY = 'login-history',
	COMPANIES = 'companies',
	CLIENTS = 'clients',
	CONTACTS = 'contacts',
	CLIENT_GROUPS = 'client-groups',

	PRODUCT_TYPE_CATEGORIES = 'product-type-categories',
	PRODUCT_TYPES = 'product-types',

	CONTENT = 'contents',

	ROLES = 'roles',

	//////////////New////////////////

	DATA = 'data',
	EDIT_ACCOUNT_PASSWORD = 'edit-account-password',
	EDIT_ACCOUNT_EMAIL = 'edit-account-email',
	PACKAGES = 'packages',
	REVIEWS = 'reviews',
	WIDGETS = 'widgets',
	PAYMENTS = 'payments',
	TRANSACTIONS = 'transactions',
	TRANSACTION_STATUS = 'transaction-status',
}
